export const config = {
    apiKey: "AIzaSyDvlmeFQoIPZKmPkEcuqA1wZTZVRU0U9ZY",
    authDomain: "swipe-app-osseveld.firebaseapp.com",
    projectId: "swipe-app-osseveld",
    storageBucket: "swipe-app-osseveld.appspot.com",
    messagingSenderId: "59497159579",
    appId: "1:59497159579:web:3198bf47e9a9907623df3e",
};
